<template>
    <div class="ur-data-grid__content__group-summary ur-data-grid__content__group-summary--freeze" :style="rowStyle">
        <!-- [CELL] Checkbox cell(pseudo) -->
        <div v-if="gridInfo.opts.selectCheck" :style="checkStyle"/>
        <!-- [CELL] Group summaries -->
        <template v-for="field in gridInfo.freezeCols">
            <summary-cell :group-node="groupNode" :field="field" :key="field.value"/>
        </template>
        <!-- [CELL] Accordion cell(pseudo) -->
        <div v-if="!!gridInfo.opts.accordion" :style="accordStyle"/>
    </div>
</template>


<script>
import summaryCell from '../cell/urDataGridGroupSummaryCell.vue'

export default {
    name : 'urDataGridContentFreezeRow',
    components : {summaryCell},
    inject : ['gridInfo'],
    props : {groupNode : Object},
    computed : {
        // [COMPUTED][VALUE] Group-Sumamry height
        height() {return this.gridInfo.opts.groupSummaryHeight},
        // [COMPUTED][STYLE] Group-Summary row
        rowStyle() {
            var style = {}
            style.height= this.height+'px'
            style.width = this.gridInfo.vars_freezeWidth+'px'
            return style
        },
        // [COMPUTED][STYLE] Checkbox(pseudo)
        checkStyle() {
            let style = {};
            style['height'] = this.height+"px";
            style['flex'] = '0 0 '+this.gridInfo.opts.selectCheckboxWidth+'px';
            style['min-width'] = '0px'
            return style;
        },
        // [COMPUTED][STYLE] Accordion(pseudo)
        accordStyle() {
            let style = {};
            style['height'] = this.height+"px";
            style['flex'] = '0 0 '+this.gridInfo.opts.accordionColumnWidth+'px';
            style['min-width'] = '0px';
            return style;
        },
    }
}
</script>